import axiosInstance from "../../utils/axiosCompany";

// Brand level reports, all under company/brand-report. Outlet level reports stay
// under company/report in report.services.js. No company_id is sent: it comes
// from the token. Every export answers at once with { jobId, message } and builds
// the file in the background; the file arrives over the socket.

// Sales
export const ListBrandSalesReport = async (values) => {
    return await axiosInstance().post("company/brand-report/sales-report", values);
}
export const ExportBrandSalesReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-sales-report", values);
}

// Item cost calculation
export const ListBrandItemCostCalculationReport = async (values) => {
    return await axiosInstance().post("company/brand-report/item-cost-calculation-report", values);
}
export const ExportBrandItemCostCalculationReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-item-cost-calculation-report", values);
}

// ERP (read only)
export const ListBrandERPSalesReport = async (values) => {
    return await axiosInstance().post("company/brand-report/erp-sales-report", values);
}
export const ExportBrandERPSalesReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-erp-sales-report", values);
}
export const ListBrandERPPaymentReport = async (values) => {
    return await axiosInstance().post("company/brand-report/erp-payment-report", values);
}
export const ExportBrandERPPaymentReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-erp-payment-report", values);
}
export const ListBrandERPCommissionsReport = async (values) => {
    return await axiosInstance().post("company/brand-report/erp-commissions-report", values);
}
export const ExportBrandERPCommissionsReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-erp-commissions-report", values);
}

// ZATCA reconciliation
export const ListBrandZatcaReport = async (values) => {
    return await axiosInstance().post("company/brand-report/zatca-report", values);
}
export const ExportBrandZatcaReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-zatca-report", values);
}
// Same request and rows as ListBrandZatcaReport, read from the stored zatca_reports
// table (built at sales EOD, updated by re-syncs) instead of recalculated live.
export const ListBrandZatcaReportNew = async (values) => {
    return await axiosInstance().post("company/brand-report/zatca-report-new", values);
}

// Discount / refund / waste. List body { page, per_page, global_search,
// search: { brand_ids, outlet_ids, business_date: { start, end } } } returns
// { rows, count }; the export takes the same body without paging, and the
// view takes { id } from a list row.
export const ListBrandDiscountReport = async (values) => {
    return await axiosInstance().post("company/brand-report/discount-report", values);
}
export const ExportBrandDiscountReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-discount-report", values);
}
export const ViewBrandDiscountReport = async (values) => {
    return await axiosInstance().post("company/brand-report/view-discount-report", values);
}
export const ListBrandRefundReport = async (values) => {
    return await axiosInstance().post("company/brand-report/refund-report", values);
}
export const ExportBrandRefundReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-refund-report", values);
}
export const ViewBrandRefundReport = async (values) => {
    return await axiosInstance().post("company/brand-report/view-refund-report", values);
}
export const ListBrandWasteReport = async (values) => {
    return await axiosInstance().post("company/brand-report/waste-report", values);
}
export const ExportBrandWasteReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-waste-report", values);
}

// Payment (one row per outlet, business date and tender) and stock movement
// (one row per outlet, business date and inventory). Same list body as above;
// without business_date each outlet shows its latest closed business day.
export const ListBrandPaymentReport = async (values) => {
    return await axiosInstance().post("company/brand-report/payment-report", values);
}
export const ExportBrandPaymentReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-payment-report", values);
}
export const ListBrandStockMovementReport = async (values) => {
    return await axiosInstance().post("company/brand-report/stock-movement-report", values);
}
export const ExportBrandStockMovementReport = async (values) => {
    return await axiosInstance().post("company/brand-report/export-stock-movement-report", values);
}
